// @flow

import React, { Component, type ComponentType } from 'react';

const scrollTop = <Props>(
  BaseComponent: ComponentType<Props>
): ComponentType<Props> => {
  return class ScrollTop extends Component<Props> {
    componentDidMount() {
      window.scrollTo(window.pageXOffset, 0);
    }

    render() {
      return <BaseComponent {...this.props} />;
    }
  };
};

export default scrollTop;
